import { render, staticRenderFns } from "./Multa.vue?vue&type=template&id=8688683e&scoped=true"
import script from "./Multa.vue?vue&type=script&lang=js"
export * from "./Multa.vue?vue&type=script&lang=js"
import style0 from "./Multa.vue?vue&type=style&index=0&id=8688683e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8688683e",
  null
  
)

export default component.exports